import React, { useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import ListItemText from '@mui/material/ListItemText';
import ListItem from '@mui/material/ListItem';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import Slide from '@mui/material/Slide';
import CardSelector from '../CardSelector';
import { useDispatch } from 'react-redux';
import { get_all_boards, resetSelectedBoardIds, addOrRemoveSelectedBoard } from 'src/redux/slices/boardSlice';
import { getPlayPercentage, getBetAmount } from 'src/redux/slices/userSlice';
import { useSelector } from 'react-redux';
import Sldr from '@mui/material/Slider';
import { Stack } from '@mui/system';
import { TextField, InputAdornment, IconButton } from '@mui/material';
import Iconify from '../../iconify';
import {
  reset_gamePlay_data,
  set_bet_amount,
  set_fixed_amount,
  set_game_type,
  set_total_players,
} from 'src/redux/slices/gamePlaySlice';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const marks = [
  {
    value: 1,
    label: '1',
  },
  {
    value: 2,
    label: '2',
  },
  {
    value: 3,
    label: '3',
  },
  {
    value: 4,
    label: '4',
  },
  {
    value: 5,
    label: '5',
  },
  {
    value: 6,
    label: '6',
  },
  {
    value: 7,
    label: '7',
  },
  {
    value: 8,
    label: '8',
  },
];

import { get_credit_for_user } from 'src/redux/slices/creditSlice';
import { create_winning_transaction } from 'src/redux/slices/gamePlaySlice';
import { v4 as uuidv4 } from 'uuid';

function CartelaSelect({ enable_cartela_selection, show_number_of_players, show_game_type,disableCartela, }) {
  const [open, setOpen] = React.useState(false);

  const logged_in_user = useSelector((state) => state.auth.user);
  const bet_amount = useSelector((state) => state.transactionState.bet_amount);

  const game_type = useSelector((state) => state.transactionState.game_type);
  const is_game_restart = useSelector((state) => state.transactionState.is_game_restart);

  const game_typex = useSelector((state) => state.auth.play_percentage); //play percentage set from admin
  const bet_amountx = useSelector((state) => state.auth.bet_amount); //bet amount set from admin

  const fixed_winning = useSelector((state) => state.transactionState.fixed_winning);
  const selectedBoards = useSelector((state) => state.boards.selected_board_ids);
  const all_boards = useSelector((state) => state.boards.available_playing_boards);
  const total_winning = useSelector((state) => state.transactionState.total_winning);
  const unique_trx_key = useSelector((state) => state.transactionState.unique_client_id);

  const idempotencyKey = uuidv4(); // Generate a unique idempotency key for the transaction


  const [board_number, set_board_number] = useState(null);

  const dispatch = useDispatch();

  useEffect(() => {
    async function getPlayPercent() {
      await dispatch(getPlayPercentage());
      await dispatch(getBetAmount());
    }
    getPlayPercent();
  }, [game_typex, bet_amountx]);

  useEffect(() => {
    dispatch(set_bet_amount(bet_amountx));
  }, [bet_amountx]);

  const handleClickOpen = () => {
    dispatch(get_all_boards(logged_in_user.branch));
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    //dispatch(reset_gamePlay_data());
    //dispatch(resetSelectedBoardIds());
  };

  const handleClear = () => {
    setOpen(false);
    dispatch(reset_gamePlay_data());
    dispatch(resetSelectedBoardIds());
  };

  /*const handleSave = () => {
      //console.log(selectedBoards.length);
        setOpen(false);
        dispatch(set_total_players(selectedBoards.length));
    }*/

  // const handleSave = async () => {
  //   if (selectedBoards.length === 0) {
  //     alert('Please select boards and set a valid bet amount.');
  //     return;
  //   }
  //   setOpen(false);
  //   if (show_game_type) {
  //     await dispatch(getPlayPercentage());
  //   }
  //   await dispatch(
  //     set_total_players({
  //       _total_players: selectedBoards.length,
  //       _saved_game_type: show_game_type,
  //       _play_percent: game_typex,
  //     })
  //   );
  //   //save game to db
  //   await save_game_to_db();
  // };

  const [isSaving, setIsSaving] = useState(false);

const handleSave = async () => {
  if (isSaving) return; // guard against double-clicks
  if (selectedBoards.length === 0) {
    alert('Please select boards and set a valid bet amount.');
    return;
  }

  setIsSaving(true); // block further clicks
  try {
    setOpen(false);
    if (show_game_type) {
      await dispatch(getPlayPercentage());
    }

    await dispatch(
      set_total_players({
        _total_players: selectedBoards.length,
        _saved_game_type: show_game_type,
        _play_percent: game_typex,
      })
    );

    await save_game_to_db();
  } finally {
    setIsSaving(false); // re-enable after all async ops
  }
};

  const getLocation = () => {
    return new Promise((resolve, reject) => {
      try {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            const lat = position.coords.latitude;
            const lon = position.coords.longitude;
            resolve({ lat, lon });
          },
          (error) => {
            reject(error);
          }
        );
      } catch (error) {
        reject(error);
      }
    });
  };

  const save_game_to_db = async () => {
    try {
      
      if (
      logged_in_user.role !== 'Employee' &&
      logged_in_user.role !== 'super' &&
      logged_in_user.role !== 'root'
    ) {
      alert('only cashiers have privilege to start new games! \n (ከ ካሺየር በስተቀር ማጫወት አይቻልም!)');
      return;
    }

      const result = await dispatch(get_credit_for_user(logged_in_user.phone));
    if (
      get_credit_for_user.rejected.match(result) ||
      !result.payload ||
      !result.payload.data ||
      result.payload.data.remaining_credit < bet_amount * selectedBoards.length - total_winning
    ) {
      alert('Insufficient credit balance to start the game!');
      return;
    }

    let _lat = 0;
    let _lon = 0;
    try {
      const { lat, lon } = await getLocation();
      _lat = lat;
      _lon = lon;
    } catch (error) {
      console.error('Error getting location:', error);
    }
    // proceed with saving the game

    const timestamp = new Date().getTime();
    const random = Math.floor(Math.random() * 10000);
    const trx_id = `${timestamp}-${random}`;
    debugger;
    const game_data_to_save = {
      trx_id,
      game_type: game_type,//show_game_type? game_type: game_typex,
      bet_amount: /*show_game_type?*/ bet_amount/*: bet_amountx*/,
      winning_board_id: -1,
      fixed_amount: fixed_winning,
      selected_boards: selectedBoards,
      call_list: [], //this.state.previousCallList,
      lat: _lat,
      lon: _lon,
      is_failed_save: false,
      use_assigned_game_type: show_game_type,
      from:'C',
      client_unique_id:unique_trx_key??idempotencyKey,
    };

    try {
      disableCartela();
      const gameData = await dispatch(create_winning_transaction(game_data_to_save));
      if (create_winning_transaction.rejected.match(result)) {
        console.error('Transaction save failed', result.error);
        // optionally save to localStorage or retry queue
      }
      
    } catch (error) {
      console.error('Failed to save transaction:', error);
      // game_data_to_save.is_failed_save = true;
      // saveFailedTransactionToLocalStorage(game_data_to_save);
    }
    } catch (error) {
      console.log(error);
    }
  };

  const _handleCartelaKeyDown = async (e) => {
    if (e.key === 'Enter' && board_number > 0) {
      //console.log(all_boards);
      if (all_boards?.some((t) => t.board_id == board_number)) {
        if (selectedBoards?.includes(board_number)) {
          var conf = confirm('Board number already selected. Do you want to deselect it?');
          if (conf) {
            if(!is_game_restart){
              dispatch(addOrRemoveSelectedBoard(board_number));
              set_board_number('');
            }else{
              alert('You cannot deselect a board in a restarted game. [RESET for clean start.]');
            }
          }
        } else {
          dispatch(addOrRemoveSelectedBoard(board_number));
          set_board_number('');
        }
      } else {
        alert(`cartela number ${board_number} not available!`);
      }
    }
  };

  const handleGameTypeValue = (typeValue) => {
    if (typeValue > 16) {
      // Check if the value is a multiple of 2
      if (typeValue % 2 === 0) {
        return (typeValue * 2) / 5;
      } else {
        // Round to the next multiple of 2 and then perform the operation
        const nextMultipleOfTwo = Math.ceil(typeValue / 2) * 2;
        const res = ((nextMultipleOfTwo * 2) / 5);
        return res > 16 ? 8 : Math.ceil(res);
      }
    }
    return typeValue; // return the original value if not greater than 12
  };

  return (
    <>
      <button disabled={!enable_cartela_selection} onClick={handleClickOpen}>
        Select Cartela
      </button>

      <Dialog fullScreen open={open} onClose={handleClose} TransitionComponent={Transition}>
        <AppBar sx={{ position: 'relative', backgroundColor: 'white', color: 'black' }}>
          <Toolbar>
            <IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close">
              <CloseIcon />
            </IconButton>
            <Stack
              direction={'row'}
              sx={{
                padding: '12px',
                gap: '24px',
                width: '100%',
                alignItems: 'center',
                margin: 'auto',
                borderRadius: '10px',
              }}
            >
              <TextField
                sx={{
                  input: { textAlign: 'center', fontWeight: 'bolder', fontSize: '24px', boxSizing: 'content-box' },
                  label: { color: 'rgb(9, 14, 44)' },
                }}
                style={{ display: logged_in_user.is_fixed_winning ? 'none' : 'block' }}
                error=""
                name="gametype"
                label="Game Type"
                type="number"
                min={1}
                max={16}
                value={
                  show_game_type
                    ? handleGameTypeValue(game_type)
                    : game_typex && parseInt(game_typex) > 0
                    ? game_type < game_typex
                      ? handleGameTypeValue(game_typex)
                      : handleGameTypeValue(game_type)
                    : handleGameTypeValue(game_type)
                }
                InputProps={{
                  inputMode: 'numeric',
                  pattern: '[0-9]*',
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        sx={{ color: 'rgb(9, 14, 44)', padding: '0px' }}
                        onClick={() => {
                          if (show_game_type) {
                            dispatch(set_game_type(game_type - 1));
                          } else {
                            if (game_typex && parseInt(game_typex) > 0) {
                              console.log(game_typex);
                              if (game_type <= game_typex) {
                                dispatch(set_game_type(game_typex));
                              } else {
                                dispatch(set_game_type(game_type - 1));
                              }
                            } else {
                              dispatch(set_game_type(game_type - 1));
                            }
                          }
                        }}
                        edge="end"
                      >
                        <Iconify style={{ width: '32px', height: '32px' }} icon="ci:minus-square" />
                      </IconButton>
                    </InputAdornment>
                  ),
                  startAdornment: (
                    <InputAdornment position="start" sx={{ padding: '0px' }}>
                      <IconButton
                        sx={{ color: 'rgb(9, 14, 44)', padding: '0px' }}
                        onClick={() => dispatch(set_game_type(game_type + 1))}
                        edge="end"
                      >
                        <Iconify style={{ width: '32px', height: '32px' }} icon="material-symbols:add-box" />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />

              <TextField
                sx={{
                  input: { textAlign: 'center', fontWeight: 'bolder', fontSize: '24px', boxSizing: 'content-box' },
                  label: { color: 'rgb(9, 14, 44)' },
                }}
                error=""
                name="bet"
                label="BET"
                type="number"
                onChange={(e) => dispatch(set_bet_amount(e.target.value))}
                value={
                  bet_amountx && parseInt(bet_amountx) > 0
                    ? bet_amount < bet_amountx
                      ? bet_amountx
                      : bet_amount
                    : bet_amount
                } // {bet_amountx == null ? bet_amount < 0 ? 20 : bet_amount : bet_amountx}
                InputProps={{
                  inputMode: 'numeric',
                  pattern: '[0-9]*',
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        sx={{ color: 'rgb(9, 14, 44)', padding: '0px' }}
                        onClick={() => {
                          
                          if (logged_in_user?.betAmount && logged_in_user?.betAmount > 0) {
                            if (bet_amount > logged_in_user?.betAmount) {
                              if (bet_amount - 5 < 10) {
                                dispatch(set_bet_amount(10));
                              } else {
                                dispatch(set_bet_amount(parseInt(bet_amount) - 5));
                              }
                            }
                          } else {
                            if (bet_amount <= 10) dispatch(set_bet_amount(10));
                            else dispatch(set_bet_amount(parseInt(bet_amount) - 5));
                          }
                        }} //{bet_amountx == null ? () => dispatch(set_bet_amount(parseInt(bet_amount) - 5)) : ()=>{console.log(bet_amountx)}}
                        edge="end"
                      >
                        <Iconify style={{ width: '32px', height: '32px' }} icon="ci:minus-square" />
                      </IconButton>
                    </InputAdornment>
                  ),
                  startAdornment: (
                    <InputAdornment position="start" sx={{ padding: '0px' }}>
                      <IconButton
                        sx={{ color: 'rgb(9, 14, 44)', padding: '0px' }}
                        onClick={() => dispatch(set_bet_amount(parseInt(bet_amount) + 5))} //{() => dispatch(set_bet_amount((bet_amountx && parseInt(bet_amountx) > 0) ? parseInt(bet_amountx) + 5 : parseInt(bet_amount) + 5))}
                        edge="end"
                      >
                        <Iconify style={{ width: '32px', height: '32px' }} icon="material-symbols:add-box" />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
              <TextField
                sx={{
                  input: { textAlign: 'center', fontWeight: 'bolder', fontSize: '24px', boxSizing: 'content-box' },
                  label: { color: 'rgb(9, 14, 44)' },
                }}
                style={{ display: logged_in_user.is_fixed_winning ? 'block' : 'none' }}
                error=""
                name="winning"
                label="Total Winning"
                type="number"
                value={fixed_winning}
                onChange={(e) => dispatch(set_fixed_amount(e.target.value))}
              />

              {show_number_of_players && (
                <TextField
                  sx={{
                    input: { textAlign: 'center', fontWeight: 'bolder', fontSize: '24px', boxSizing: 'content-box' },
                    label: { color: 'rgb(9, 14, 44)' },
                  }}
                  error=""
                  name="winning"
                  value={selectedBoards?.length > 0 ? selectedBoards?.length / 2 + '' : ''}
                  type="text"
                />
              )}

              <TextField
                sx={{
                  input: { textAlign: 'center', fontWeight: 'bolder', fontSize: '24px', boxSizing: 'content-box' },
                  label: { color: 'rgb(9, 14, 44)' },
                }}
                error=""
                name="autoAdd"
                label="Add Cartela"
                //type="number"
                value={board_number}
                onKeyDown={_handleCartelaKeyDown}
                onChange={(e) => set_board_number(Number(e.target.value))}
                InputProps={{
                  inputMode: 'numeric',
                  pattern: '[0-9]*',
                }}
              />
            </Stack>

            {/* <Button autoFocus color="inherit" onClick={handleSave}>
              Save
            </Button> */}

            <Button autoFocus color="inherit" onClick={handleSave} disabled={isSaving}>
              {isSaving ? 'Saving...' : 'Save'}
            </Button>

            <Button autoFocus color="inherit" onClick={handleClear}>
              Clear
            </Button>
          </Toolbar>
        </AppBar>
        <Stack direction={'column'}>
          <CardSelector />
        </Stack>
      </Dialog>
    </>
  );
}

export default CartelaSelect;
